import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { KeywordItem } from '../type';

export interface KeywordGroupService {
    handleDeleteItem: (listData: KeywordItem[], index: number) => KeywordItem[];
}

export const KeywordGroupService = Symbol('KeywordGroupService');

@injectable()
export class KeywordGroupServiceImpl implements KeywordGroupService {
    public handleDeleteItem(listData: KeywordItem[], index: number): KeywordItem[] {
        return listData.filter((value, _index) => _index !== index);
    }
}
